<template>
  <div>
    <div v-for="(g, gidx) in permissionGroup" :key="`group-${gidx}`">
      <h5>{{ $t(`permission.${g.module}`) }}</h5>

      <b-row class="mb-2">
        <b-col
          cols="auto"
          v-for="(p, pidx) in g.permissions"
          :key="`permission-${pidx}`"
        >
          <b-form-checkbox
            class="vs-checkbox-con"
            :checked="getCheckPermission(p)"
            @change="checkAbility(p, $event)"
          >
            <span class="vs-checkbox">
              <span class="vs-checkbox--check">
                <i class="vs-icon feather icon-check" />
              </span>
            </span>
            {{ $t(`permission.${p.code}`) }}
          </b-form-checkbox>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BRow, BCol, BFormCheckbox } from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BFormCheckbox,
  },
  props: {
    value: {},
    permissionGroup: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    value(value) {
      this.permissions = value;
    },
  },
  data() {
    return {
      permissions: [],
    };
  },
  methods: {
    checkAbility(item, checked) {
      if (checked !== true && checked !== false) {
        return;
      }

      if (checked) {
        this.permissions.push(item.id);
      } else {
        const index = this.permissions.findIndex((element) => {
          return element == item.id;
        });
        this.permissions.splice(index, 1);
      }
      this.input();
    },
    getCheckPermission(item) {
      const index = this.value.findIndex((element) => {
        return element == item.id;
      });

      return index !== -1;
    },
    input() {
      this.$emit("input", this.permissions);
    },
  },
};
</script>